//libs
import React, { memo, useState, useEffect, useMemo } from "react";
import debounce from "lodash/debounce";

//components
import FakeScroller from "shared/components/FakeScroller";
import Search from "./components/Search";
import Categories from "./components/Categories";
import AllBrands from "./components/AllBrands";
//helpers
import { bucketizeBrands } from "shared/components/Header/helpers";
import { getAllBrands, getFilteredBrands } from "shared/components/Header/helpers";

//constants
import { BrandsSubMenu } from "./styles";
import BrandsHeader from "./components/BrandsHeader";
import { DEFAULT_INITIALS } from "shared/components/Header/constants";

interface IBrandsProps {
    data: any;
}

function Brands({ data }: IBrandsProps) {
    const [filterText, setFilterText] = useState<string>("");
    const [filteredBrands, setBrands] = useState<any>({});
    const [selectedBrandId, setSelectedBrandId] = useState<number>(0);
    const [selectedCategory, setSelectedCategory] = useState("");
    const allBrands = useMemo(() => getAllBrands(data), [data]);
    const allBucketizedBrands = bucketizeBrands(allBrands);
    const [localFilteredBrands, setLocalFilteredBrands] = useState(allBucketizedBrands);

    useEffect(() => {
        const brands = getFilteredBrands(filterText, allBrands);
        setBrands(bucketizeBrands(brands));
    }, [allBrands, filterText]);

    useEffect(() => {
        setLocalFilteredBrands(filteredBrands);
    }, [filteredBrands]);

    const onSearchChange = debounce((newFilterText: string) => {
        setFilterText(newFilterText);
        setSelectedBrandId(-1);
    }, 300);

    const allBrandsCategory = useMemo(
        () => ({
            title: "All Brands",
            isActive: true,
            children: allBrands,
        }),
        [allBrands]
    );

    return (
        <BrandsSubMenu>
            <div className="br-header">
                <Search onChange={onSearchChange} />
                <BrandsHeader
                    allInitials={DEFAULT_INITIALS}
                    availableBrands={filteredBrands}
                    setFilteredBrands={setLocalFilteredBrands}
                    setSelectedCategory={setSelectedCategory}
                />
            </div>

            <div className="br-content">
                <div className="br-categories">
                    <FakeScroller>
                        <Categories
                            data={data.children}
                            updateFilteredBrands={setBrands}
                            updateSelectedBrandId={setSelectedBrandId}
                            selectedBrandId={selectedBrandId}
                            allBrandsCategory={allBrandsCategory}
                            showAllBrands
                        />
                    </FakeScroller>
                </div>
                <AllBrands
                    availableBrands={localFilteredBrands}
                    selectedCategory={selectedCategory}
                />
            </div>
        </BrandsSubMenu>
    );
}

export default memo(Brands);
